import { Component, Input } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ui-page-container',
  styleUrls: ['./page-container.component.scss'],
  templateUrl: './page-container.component.html',
})
export class PageContainerComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'large';
}
